export class AuditLogFieldChange {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "string",
            "format": ""
        },
        {
            "name": "oldValue",
            "baseName": "oldValue",
            "type": "string",
            "format": ""
        },
        {
            "name": "newValue",
            "baseName": "newValue",
            "type": "string",
            "format": ""
        },
        {
            "name": "redacted",
            "baseName": "redacted",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLogFieldChange.attributeTypeMap;
    }
    constructor() {
    }
}
